<template>
  <div class="hotTagsVideo clearfix">
    <div
      class="videoBox"
      v-for="(item, i) in list"
      :key="i"
      @click.stop.prevent="gotoVideo(item.videoId)"
    >
      <div class="videoImg">
        <img class="bgImg" :src="item.thumb | imageUrl('', 510, 288)" alt="" />
        <div class="pop">
          <img class="popImg" src="/static/home/play_tri_40@2x.png" alt="" />
        </div>
      </div>
      <p class="title">{{ language === 'zh' ? item.title : item.enTitle || item.title }}</p>
      <div class="tagBox clearfix">
        <p class="tags">
          <span v-for="(index, y) in item.categoryTagGroupInfoList" :key="y">{{
            index
          }}</span>
        </p>
        <!-- <p class="count">
          <img class="countIcon" src="/static/home/view_icon@2x.png" alt="" />{{
            item.viewCount
          }}
        </p> -->
      </div>
      <div class="name" @click.stop.prevent="gotopeople(item.userId)">
        <img
          class="icon"
          :src="
            type == 2 ? item.userAvatar : item.avatar | imageUrl('/static/profile_img_default.png', 40, 40)
          "
          alt=""
        />{{ type == 2 ? item.userNickName : item.nickName }}
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "hotTagsVideo",
  data() {
    return {};
  },
  methods: {
    gotoVideo(id) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + id,
      });
      window.open(routeData.href, "_blank");
    },
    gotopeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
  },
  props: {
    list: Array,
    type: Number,
  },
  created() {},
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.hotTagsVideo {
  width: 1110px;
  .videoBox {
    width: 255px;
    float: left;
    margin-right: 30px;
    margin-bottom: 24px;
    cursor: pointer;
    height: 248px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .videoImg {
      width: 255px;
      height: 144px;
      margin-bottom: 10px;
      position: relative;
      cursor: pointer;

      .bgImg {
        width: 100%;
        height: 100%;
      }

      .pop {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;

        .popImg {
          position: absolute;
          width: 21px;
          height: 28px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .title {
      width: 255px;
      min-height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #0A0A0A;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
    }

    .tagBox {
      height: 18px;
      line-height: 18px;
      margin: 8px 0;

      .tags {
        float: left;
        width: 255px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        span {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          margin-right: 5px;
        }
      }

      .count {
        float: right;
        font-size: 12px;
        font-weight: 400;
        color: #B8B8B8;

        .countIcon {
          width: 18px;
          height: 14px;
          margin-right: 2px;
          margin-bottom: 2px;
        }
      }
    }

    .name {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:hover {
          color: #0A0A0A;
      }
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 6px;
      }
    }

    &:hover .videoImg .pop {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/changeVideoList.vue